// extracted by mini-css-extract-plugin
module.exports = {"banner":"contact-module--banner--190H6","titre":"contact-module--titre--1nlyy","sousTitre":"contact-module--sousTitre--1VL99","file":"contact-module--file--1uqIg"};